import initTabelaGenerica from '../mixins/initTabelaGenerica'
import { Grid, html as htmlGrid } from 'gridjs'
import SelectMultiple from '../components/SelectMultiple'
import ModalResumo from '../components/ModalResumo.js'
import { capitalize, uniqBy } from 'lodash'
import { reuniaoService } from '../services/reuniao.service.js'
import { MONTHS_LIST } from '../constants/reuniao.js'
import atendimentoSequoiaService from '../services/atendimentoSequoia.service.js'

const URL = {
	reunioes_realizadas_sai: '/atendimento/atendimento_sequoia/',
}

export default {
	mixins: [initTabelaGenerica],
	emits: ['clickFundacaoAtendimentoRapido', 'clickFundacaoNome'],
	props: {
		query: {
			type: Object,
			default: () => ({
				user: [],
				tem_atendimento: 'true',
				ano_inicio: '',
				mes_inicio_ano_inicial: '',
				mes_fim_ano_inicial: 12,
				ano_fim: '',
				mes_inicio_ano_final: 1,
				mes_fim_ano_final: '',
			}),
			required: true,
		},
		az: {
			type: Number,
			default: 4,
			required: true,
		},
	},
	data() {
		return {
			tableReunioesRealizadas: null,
			usuariosComReuniaoRealizadas: [],
			fundacoes_sequoia: [],
			mesesClientesSemReuniao: [],
			columns: [],
			usuarios: [],
			atendimentos_por_fundacao: [],
		}
	},
	methods: {
		onClickFundacaoAtendimentRapido(id) {
			this.$emit('clickFundacaoAtendimentoRapido', { id: id })
		},

		onClickFundacaoInfo(id) {
			const atendimentosFundacao = this.atendimentos_por_fundacao.find(
				(item) => item.fundacao_id === Number(id)
			)

			this.$emit('clickFundacaoNome', {
				atendimentosFundacao: atendimentosFundacao,
			})
		},

		parseBrDateToDate(dateBrStr) {
			const [day, month, year] = dateBrStr.split('/')
			return new Date(`${year}-${month}-${day}T00:00:00`)
		},

		normalizeDate(date) {
			const normalized = new Date(date)
			normalized.setHours(0, 0, 0, 0)
			return normalized
		},

		areDatesEqual(isoDateStr, brDateStr) {
			const isoDate = this.normalizeDate(new Date(isoDateStr))
			const brDate = this.normalizeDate(this.parseBrDateToDate(brDateStr))

			return isoDate.getTime() === brDate.getTime()
		},

		async init() {
			const data = await this.getDados()

			setTimeout(() => {
				this.iniciartableReunioesRealizadas()
			}, 1000)
		},

		iniciartableReunioesRealizadas() {
			const resultado = []

			const tabela = document.getElementById('table_gerencial_sai')

			this.tableReunioesRealizadas = this.iniciarTabelaGenerica(
				this.columns,
				`${window.origin}${URL.reunioes_realizadas_sai}`,
				(data) => {
					const {
						meses_clientes_sem_reuniao,
						meses_clientes_sem_reuniao_ano_atual,
						results,
					} = data
					this.mesesClientesSemReuniao = [
						...meses_clientes_sem_reuniao,
						...meses_clientes_sem_reuniao_ano_atual,
					]
					this.atendimentos_por_fundacao = data.atendimentos_por_fundacao || []
					return this.formataResultsForGrid(data, resultado)
				},
				(data) => {
					const {
						meses_clientes_sem_reuniao,
						meses_clientes_sem_reuniao_ano_atual,
						results,
					} = data
					this.mesesClientesSemReuniao = [
						...meses_clientes_sem_reuniao,
						...meses_clientes_sem_reuniao_ano_atual,
					]

					return this.formataResultsForGrid(data, resultado)
				}
			)

			if (this.tableReunioesRealizadas && tabela) {
				this.tableReunioesRealizadas.on('ready', () => {
					this.paintMesesAtrasados()

					document
						.getElementById('table_gerencial_sai')
						.addEventListener('click', (e) => {
							const atendimentoId = e.target.closest('[data-atendimento-id]')

							if (atendimentoId) {
								const idFundacao = atendimentoId.getAttribute(
									'data-atendimento-id'
								)

								this.onClickFundacaoAtendimentRapido(Number(idFundacao))
							} else {
								const infoId = e.target.closest('[data-info-id]')

								if (infoId) {
									const idFundacao = infoId.getAttribute('data-info-id')
									this.onClickFundacaoInfo(idFundacao)
								}
							}
						})
				})
				this.tableReunioesRealizadas.render(tabela)
			}
		},

		async getDados() {
			const { getAtendimentos } = atendimentoSequoiaService()
			const data = await getAtendimentos()

			this.fundacoes_sequoia = data.fundacoes_sequoia
			
			this.usuariosComReuniaoRealizadas = uniqBy(
				[
					...data.meses_filtrados_ano_final.flat(),
					...data.meses_filtrados_ano_inicial.flat(),
				],
				'fundacao_id'
			)

			this.columns = this.buildColumns(data)
			this.mesesClientesSemReuniao = [
				...data.meses_clientes_sem_reuniao,
				...data.meses_clientes_sem_reuniao_ano_atual,
			]
			/* 	this.usuarios = data.todos_users.map((user) => ({
				label: user.username,
				value: user.id,
			})) */

			return data
		},

		buildQuery() {
			const today = new Date()
			const currentYear = today.getFullYear()
			const currentMonth = today.getMonth() + 1
			const twoDigits = (n) => (n < 10 ? '0' + n : String(n))

			const defaults = {
				ano_inicio: String(currentYear - 1),
				ano_fim: String(currentYear),
				mes_inicio_ano_inicial: twoDigits(currentMonth),
				mes_fim_ano_inicial: '12',
				mes_inicio_ano_final: '01',
				mes_fim_ano_final: twoDigits(currentMonth),
				tem_atendimento: 'false',
				az: 4,
			}

			const {
				user,
				tem_atendimento,
				ano_inicio,
				mes_inicio_ano_inicial,
				mes_fim_ano_inicial,
				ano_fim,
				mes_inicio_ano_final,
				mes_fim_ano_final,
			} = this.query

			const finalParams = {
				ano_inicio:
					ano_inicio && ano_inicio !== '' ? ano_inicio : defaults.ano_inicio,

				ano_fim: ano_fim && ano_fim !== '' ? ano_fim : defaults.ano_fim,

				mes_inicio_ano_inicial:
					mes_inicio_ano_inicial && mes_inicio_ano_inicial !== ''
						? twoDigits(Number(mes_inicio_ano_inicial))
						: defaults.mes_inicio_ano_inicial,

				mes_fim_ano_inicial:
					mes_fim_ano_inicial && String(mes_fim_ano_inicial) !== ''
						? twoDigits(Number(mes_fim_ano_inicial))
						: defaults.mes_fim_ano_inicial,

				mes_inicio_ano_final:
					mes_inicio_ano_final && String(mes_inicio_ano_final) !== ''
						? twoDigits(Number(mes_inicio_ano_final))
						: defaults.mes_inicio_ano_final,

				mes_fim_ano_final:
					mes_fim_ano_final && mes_fim_ano_final !== ''
						? twoDigits(Number(mes_fim_ano_final))
						: defaults.mes_fim_ano_final,

				tem_atendimento:
					tem_atendimento && tem_atendimento !== ''
						? tem_atendimento
						: defaults.tem_atendimento,

				az: this.az ? this.az : defaults.az,
			}

			const params = new URLSearchParams()

			for (const [key, value] of Object.entries(finalParams)) {
				if (value !== '' && value != null) {
					params.append(key, value)
				}
			}

			if (Array.isArray(user) && user.length > 0) {
				params.append('user', user.join(','))
			}

			return params.toString()
		},

		buildColumns(data) {
			const base = [
				{ id: 'id', name: 'ID', hidden: true },
				{ id: 'politica_sequoia', name: 'Politica Sequoia', hidden: true },
				{
					id: 'nome',
					name: 'Fundaçãos',
					attributes: { 'sticky-column-1': true, 'sticky-header': true },
					width: '180px',
					formatter: (cell, row) => {
						const id = row.cells[0].data
						const politicaSequoia = row.cells[1].data

						return htmlGrid(`
							<div data-info-id="${id}" class="inline-flex justify-between items-center w-full" style="cursor: pointer;">
								<div  class="inline-flex items-center max-w-[180px]">
									<svg class="h-40 w-40 shrink-0" style="${GLOBAL.generateAvatarColor(
										politicaSequoia
									)}"><use xlink:href="#icon_person"></use></svg>
									<span class="one-line max-w-[180px]" title="${cell}">${cell}</span>
								</div>
								<button data-atendimento-id="${id}" href="#" 
									class="btn bg-transparent text-white hover:text-white hover:!bg-white/10 !border-transparent">
									<svg class="w-16 h-16 text-primary-pure !border-transparent">
										<use xlink:href="#icon_pencil"></use>
									</svg>
								</button>
							</div>
							`)
					},
					sort: {
						compare: (a, b) => {
							const fundA = this.fundacoes_sequoia?.find((i) => i.sigla === a)
							const fundB = this.fundacoes_sequoia?.find((i) => i.sigla === b)

							if (fundA?.politica_sequoia && fundB?.politica_sequoia) {
								if (fundA.politica_sequoia !== fundB.politica_sequoia) {
									return fundA.politica_sequoia.localeCompare(
										fundB.politica_sequoia
									)
								}
							}

							return (
								parseFloat(fundB?.patrimonio || 0) -
								parseFloat(fundA?.patrimonio || 0)
							)
						},
					},
				},
				{
					id: 'usuario_responsavel_atendimento',
					name: 'Officer',
					attributes: {
						'sticky-column-2': true,
						'sticky-header': true,
						center: true,
					},
					width: '85px',
					formatter: (cell) => {
						const nomesFundacoes = uniqBy(cell, 'id')
						return htmlGrid(`
								<div style="display:flex;flex-direction:column;gap:2px;max-width:85px;width:100%;align-items: center;">
								${nomesFundacoes
									.map(
										(item) => `<span class="">${capitalize(item.name)}</span>`
									)
									.join('')}
								</div>
								`)
					},
				},
			]

			const meses = [
				...data.meses_filtrados_ano_final,
				...data.meses_filtrados_ano_inicial,
			]

			meses.forEach((item, idx) => {
				base.push({
					id: item.nome,
					name: htmlGrid(
						`<div style="white-space:normal;">${capitalize(
							item.nome.replace(/_final|_inicial/g, '')
						)}</div>`
					),
					width: '70px',
					formatter: (cell, row) => this.formatMesCell(cell, row, idx + 3),
				})
			})

			return base
		},
		formatMesCell(cell, row, colIndex) {
			const idFundacao = row.cells[0].data
			const ultimo = row.cells.findIndex(
				(c, index) =>
					index >= 4 && Array.isArray(c.data) && this.isValidDate(c.data[1])
			)

			const classe = this.getAtrasoClass(ultimo - 1, colIndex)
			return htmlGrid(`
							<div class="${classe}" style="display:flex;flex-direction:column;gap:2px;">
							<span style="font-weight:600;">${cell ? cell[0] : ''}</span>
							<span>${cell ? cell[1] : ''}</span>
							</div>
							`)
		},

		isValidDate(val) {
			if (!val) return false
			const [d, m, y] = val.split('/')
			const iso = `${y}-${m}-${d}`
			return !isNaN(new Date(iso).getTime())
		},

		getAtrasoClass(ultimoIdx, colIdx) {
			if (colIdx >= ultimoIdx) return ''

			const diff = ultimoIdx - 3
			if (diff >= 1 && diff <= 6) return 'atraso_entre_1_6'
			if (diff > 6) return 'atraso_maior_6'
			return ''
		},

		formataObjectsInicialFinal(lista_inicial, lista_final) {
			const objectReunioes = {
				...Object.fromEntries(
					Object.entries(lista_inicial).map(([key, value]) => [
						`${key}_inicial`,
						value,
					])
				),
				...Object.fromEntries(
					Object.entries(lista_final).map(([key, value]) => [
						`${key}_final`,
						value,
					])
				),
			}

			return objectReunioes
		},
		// Reaproveita lógica original de formatação
		formataResultsForGrid(results, resultado = []) {
			const formatoFinal = []
			const fundacoes = results.fundacoes_sequoia

			const dadosReuniao = this.formataObjectsInicialFinal(
				results?.reunioes_ano_inicial,
				results?.reunioes_ano_final
			)

			fundacoes.forEach((itemFundacao) => {
				const atendimentosPorCliente = []
				let politicaFundacao = itemFundacao.politica_sequoia // ← Inicializa com o valor da fundação

				Object.entries(dadosReuniao).forEach(([mes, atendimentoMes]) => {
					const atendimentos = atendimentoMes.filter(
						(atendimento) => atendimento.fundacao_id === itemFundacao.id
					)
					atendimentos.forEach((atendimento) => {
						const {
							usuario_responsavel_atendimento,
							data_atendimento,
							qtd_reunioes,
							politica,
						} = atendimento

						atendimentosPorCliente.push({
							usuario_responsavel_atendimento,
							mes: mes,
							data_atendimento,
							qtd_reunioes,
						})
					})
				})

				const resultado = [
					itemFundacao.id,
					politicaFundacao,
					itemFundacao.sigla,
				]

				if (atendimentosPorCliente && atendimentosPorCliente.length > 0) {
					const arrayOfficers = atendimentosPorCliente.map(
						(itemAtendimento) => itemAtendimento.usuario_responsavel_atendimento
					)
					const arrayUnico = [...new Set(arrayOfficers.flat())]
					const user = uniqBy(arrayUnico, 'id')

					resultado.push(user)
				} else {
					resultado.push('')
				}

				const novoArrayInicial = results?.meses_filtrados_ano_inicial.map(
					(item) => ({
						...item,
						nome: item.nome + '_inicial',
					})
				)

				const novoArrayFinal = results?.meses_filtrados_ano_final.map(
					(item) => ({
						...item,
						nome: item.nome + '_final',
					})
				)
				const mesesAtendimentoTotal = [...novoArrayFinal, ...novoArrayInicial]

				const auxDiasReuniaoAtendimento = []

				mesesAtendimentoTotal.forEach((item) => {
					const atendimentoEncontrado = atendimentosPorCliente.find((a) => {
						return a.mes.toLowerCase() === item.nome.toLowerCase()
					})

					auxDiasReuniaoAtendimento.push(
						atendimentoEncontrado && atendimentoEncontrado.data_atendimento
							? [
									`Qtd: ${atendimentoEncontrado.qtd_reunioes}`,
									GLOBAL.formatDateObject(
										new Date(atendimentoEncontrado.data_atendimento)
									),
							  ]
							: ''
					)
				})

				formatoFinal.push([...resultado, ...auxDiasReuniaoAtendimento])
			})

			const auxReunioaoMesesInicial = Object.values(
				results.reunioes_ano_inicial
			).flatMap((itemReunoiaoRealizada) => [...itemReunoiaoRealizada])

			const auxReuniaoMesesFinal = Object.values(
				results.reunioes_ano_final
			).flatMap((itemReunoiaoRealizada) => [...itemReunoiaoRealizada])

			this.usuariosComReuniaoRelaizadas = [
				...auxReuniaoMesesFinal,
				...auxReunioaoMesesInicial,
			]
			this.usuariosComReuniaoRelaizadas = uniqBy(
				this.usuariosComReuniaoRelaizadas,
				'fundacao_id'
			)

			return formatoFinal
		},
		paintMesesAtrasados() {
			let timeout = 10
			let timeCount = 0

			const checkIdInterval = setInterval(() => {
				timeCount++
				const isTableRender = document.querySelector('.gridjs-td')

				if (isTableRender !== null && isTableRender.hasChildNodes()) {
					this.$nextTick(() => {
						document.querySelectorAll('.gridjs-td').forEach((td) => {
							if (td.querySelector('.atraso_entre_1_6')) {
								td.style.backgroundColor = 'rgba(28, 159, 105, 0.3)'
							}
							/* 							if (td.querySelector('.atraso_maior_4_6')) {
								td.style.backgroundColor = 'rgba(253, 212, 38, 0.3)'
							} */
							if (td.querySelector('.atraso_maior_6')) {
								td.style.backgroundColor = 'rgba(236, 53, 57, 0.3)'
							}
						})
					})

					clearInterval(checkIdInterval)
				} else if (timeCount >= timeout) {
					clearInterval(checkIdInterval)
				}
			}, 1500)
		},
	},

	mounted() {
		this.init()
	},
	template: `
				<div id="table_gerencial_sai">
				  
				</div>
			  `,
}
